import { useGetCategoryTreesByCountry } from '@/api';
import { useZepetofulFetchSchoolContent } from '@/api/zepetoful.api';
import { type ReturnUseCachedCategoryInfo } from '@/module/public/hooks/useFetchCategoryInfo';

export const useFetchCategoryInfoByCountryCode = (
  countryCode: string,
): Omit<ReturnUseCachedCategoryInfo, 'countryCode'> => {
  const { data } = useGetCategoryTreesByCountry(countryCode);
  const { data: publishersData } = useZepetofulFetchSchoolContent({
    enabled: countryCode === 'KR',
  });
  return {
    categoryTreeData: data?.data,
    publishersData: publishersData?.publishers?.KR,
  };
};
